import { CurrencyType } from "@inception/ui";
import { LeftNavItemName } from "../../../../app/leftNav/options/constants";
import { TCCustomTimeRange } from "../time-range/types";

export interface TenantConfig {
  currency: CurrencyType;
  demoTenant: boolean;
  pocTenant: boolean;
  enableBizFlow: boolean;
  defaultTimezone?: string;

  useOnboardingHome: boolean;
  useBizProcessHome: boolean;
  defaultDrilldownVersion: TenantDrilldownVersion;
  showDemoInsights: boolean;
  suggestionsLimit: number;

  showSubVerticalSwitcher: boolean;

  leftNavPreset?: LeftNavItemName[];
  disableNewDashboardFilterPanel?: boolean;
  enableCalendarInLeftNavPanel?: boolean;
  enableDiscoverySandbox?: boolean;
  customTimeRanges?: TCCustomTimeRange[];
  showSampleDataCardBanner?: boolean;
  enableNewTriageSummary?: boolean;
  enableKpiBasedOnboarding?: boolean;
  enableRecipeInOp10zePreview?: boolean;
  enableDashboardShare?: boolean;
  enableAddEntityFilter?: boolean;
  enablePartnerFeatures?: boolean;
  enableChat?: boolean;
  enableOnboardingRoute?: boolean;
  useComplexExpressions?: boolean;

  blobStoreFileUploadTimeoutMins?: number;
  useOldNavigation?: boolean;

  enableNewUiForOp10ze?: boolean;
  enableChatInterfaceForOp10ze?: boolean;
  hideChatInterfaceForDashboardCreate?: boolean;
  reportPollFrequency?: number;
  discoveryMappingPollFrequency?: number;
  enableCustomOpCreation?: boolean;
  enableDataStory?: boolean;

  alignTimeBoundaries?: boolean;
  enableTimezone?: boolean;
  defaultUserTimezone?: "browser" | "tenant";
}

export enum TenantDrilldownVersion {
  v3 = "v3",
  v4 = "v4",
  v5 = "v5"
}

export interface UITenantConfig extends Omit<TenantConfig, "useOldNavigation"> {
  useNewNavigation: boolean;
  useNewWidgetInBusinessCatalog: boolean;
}

export interface TenantConfigState {
  tenantConfig: UITenantConfig;
  isFetching: boolean;
}

export type DefaultConfig = { name: string; config: any; namespace?: string };
